import {createSlice} from '@reduxjs/toolkit';

const surveySlice = createSlice({
    name: 'survey',
    initialState: {
      departmentId: 0,
      userId:0,
      srvcUserId: 0,
      surveyData: null,
      surveyPayload: null,
      surveyList: {},
      questionMap : {},
      mandatoryMap: {},
      questionAnswerList: [],
      finalPayload: null
    },
    reducers: {
      setSurveyInfo: (state, action) => {
        //debugger;
        const { data } = action.payload;
        state.departmentId = data?.surveyList[0]?.departmentId
        state.userId = data?.userId;
        state.srvcUserId = data?.srvcUserId;
        state.surveyData = data;
        state.surveyPayload = action.payload;
        state.surveyList = action.payload.data.surveyList?.map(survey => {
          return survey.categoryList.map(category => {
            let listofquestions = category.questionList.map(question => {
              state.questionMap[question.id] = question;
              state.mandatoryMap[question.id] = question.questionMandatory;
              if (question?.optionList?.length > 0) {
                question?.optionList?.forEach(questionOption => {
                  state.mandatoryMap["questionOptionId-" + questionOption.id + "-remarks-isMandatory"] = questionOption.remarkMandatory;
                });
              }
              return question;
            });
            return {categoryName: category.categoryName, qSet: listofquestions}
          });
        });

        state.surveyData?.surveyList[0]?.categoryList[0]?.questionList?.forEach(question => {
          state.questionMap[question.id] = question;
          state.mandatoryMap[question.id] = question.questionMandatory;
          if(question?.optionList?.length > 0){
            question?.optionList?.forEach(questionOption => {
              state.mandatoryMap["questionOptionId-" + questionOption.id + "-remarks-isMandatory"] = questionOption.remarkMandatory;
            });
          }
        });
        state.finalPayload = {
          'surveyTime': state.surveyData?.surveyList[0]?.surveyTime,
          'endDate': state.surveyData?.surveyList[0]?.endDate,
          'id': state.surveyData?.surveyList[0]?.id,
          'departmentId': state.surveyData?.surveyList[0]?.departmentId,
          'surveyAttempt': state.surveyData?.surveyList[0]?.surveyAttempt,
          'userId': state.surveyData?.userId,
          'srvcUserId': state.surveyData?.surveyList[0]?.srvcUserId,
          'categoryList': []
        };
      },
      /* createMandatoryMap: (state, action) => {
        //debugger;
        const { surveyQuestionList } = action.payload;
        surveyQuestionList?.forEach(question => {
          state.questionMap[question.id] = question;
          state.mandatoryMap[question.id] = question.questionMandatory;
          if(question?.optionList?.length > 0){
            question?.optionList?.forEach(questionOption => {
              state.mandatoryMap["questionOptionId-" + questionOption.id + "-remarks-isMandatory"] = questionOption.remarkMandatory;
            });
          }
        });
      }, */
      addSurveyQuestion: (state, action) => {
        //debugger;
        const question = action.payload;
        state.questionMap[question.id] = question;
        state.mandatoryMap[question.id] = question.questionMandatory;
        if(question?.optionList?.length > 0){
          question?.optionList?.forEach(questionOption => {
            state.mandatoryMap["questionOptionId-" + questionOption.id + "-remarks-isMandatory"] = questionOption.remarkMandatory;
          });
        }
      },
      removeSurveyQuestion: (state, action) => {
        //debugger;
        const removableSurveyQuestion = action.payload;
        let fieldKey = removableSurveyQuestion.id+"";

        if (fieldKey in state.questionMap) {
          state.questionMap[fieldKey] = undefined;
          delete state.questionMap[fieldKey];
        }

        if (fieldKey in state.mandatoryMap) {
          state.mandatoryMap[fieldKey] = undefined;
          delete state.mandatoryMap[fieldKey];
        }

        if(removableSurveyQuestion?.optionList?.length > 0){
          removableSurveyQuestion?.optionList?.forEach(questionOption => {
            let optionFieldKey = "questionOptionId-" + questionOption.id + "-remarks-isMandatory";
            //debugger;
            if (optionFieldKey in state.mandatoryMap) {
              state.mandatoryMap[optionFieldKey] = undefined;
              delete state.mandatoryMap[optionFieldKey];
            }
          });
        }
      },
      setQuestionAnswerList: (state, action) => {
        //debugger;
        const newData = action.payload;
        console.log(newData.id);
        const existingIndex = state.questionAnswerList.findIndex(item => item.id === newData.id);
        if(existingIndex !== -1 && (!(newData?.answerList?.length > 0))){
          state.questionAnswerList.splice(existingIndex, 1);
        }else{
            if (existingIndex !== -1) {
              state.questionAnswerList[existingIndex] = newData;
            }else{
              if(newData?.answerList?.length > 0){
                state.questionAnswerList = [...state.questionAnswerList, newData];
              }
            }
        }
        console.log(state.questionAnswerList);
      },
      setFinalPayload: (state, action) => {
        //debugger;
        state.finalPayload = {
          ...state.finalPayload,
          categoryList: [
            {
              id: state.surveyData?.surveyList[0]?.categoryList[0]?.id,
              questionList: state.questionAnswerList
            }
          ]
        }
      }
    },
  },
);

export const { setSurveyInfo, addSurveyQuestion, removeSurveyQuestion, setQuestionAnswerList, setFinalPayload } = surveySlice.actions;
export default surveySlice.reducer;